// @import

import Alpine from "alpinejs";

const SCRIPT_SRC = "https://cdn.jsdelivr.net/gh/magma-app/magma-widget@latest/src/widget/initializer.js";

Alpine.directive("magma", (element, {}, { cleanup }) => {
  function onScriptLoaded() {
    element.style.opacity = "0";
    element.style.pointerEvents = "none";
  }

  function loadWidget() {
    // @ts-ignore
    window.magma_app = [
      {
        type: element.dataset.type,
        uuid: element.dataset.uuid,
        integrationUuid: element.dataset.integrationUuid,
        autoPopup: false,
      },
    ];

    const script = document.createElement("script");
    script.addEventListener("load", onScriptLoaded);
    script.src = SCRIPT_SRC;
    script.async = true;
    script.setAttribute("crossorigin", "anonymous");
    document.body.appendChild(script);
  }

  element.addEventListener("click", loadWidget);

  cleanup(() => {
    element.removeEventListener("click", loadWidget);
  });
});
